import { render, staticRenderFns } from "./SelectedDataDisplay.vue?vue&type=template&id=0faf6dd2&scoped=true&"
import script from "./SelectedDataDisplay.vue?vue&type=script&lang=js&"
export * from "./SelectedDataDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SelectedDataDisplay.vue?vue&type=style&index=0&id=0faf6dd2&scoped=true&lang=css&"
import style1 from "./SelectedDataDisplay.vue?vue&type=style&index=1&lang=css&"
import style2 from "./SelectedDataDisplay.vue?vue&type=style&index=2&id=0faf6dd2&scoped=true&lang=css&"
import style3 from "./SelectedDataDisplay.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf6dd2",
  null
  
)

export default component.exports